import { render, staticRenderFns } from "./EasyPayAllServicePage.vue?vue&type=template&id=ccb3dfae&scoped=true&"
import script from "./EasyPayAllServicePage.vue?vue&type=script&lang=js&"
export * from "./EasyPayAllServicePage.vue?vue&type=script&lang=js&"
import style0 from "./EasyPayAllServicePage.vue?vue&type=style&index=0&id=ccb3dfae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb3dfae",
  null
  
)

export default component.exports